import { Reveal, Overline } from "@/components/Reveal";

const BRAND_GRAPHIC = "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/f94582ba36cc65cea0b020a6a1c3dd81d4153a5df627114fcfb1efd0d3351d4a.png";

export function WhatIs() {
  return (
    <section id="whatis" data-testid="whatis-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline>¿Qué es Kairós Learning?</Overline>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.1]">
                El instante preciso en que todo se alinea.
              </h2>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-8 space-y-6 font-sans text-lg font-light leading-relaxed text-midnight/70 max-w-2xl">
                <p>
                  En griego antiguo existían dos palabras para el tiempo: <span className="italic text-midnight">chronos</span>,
                  el tiempo que se mide, y <span className="italic text-crimson font-normal">kairós</span>, el tiempo que se
                  aprovecha. El instante preciso. El momento en que todo se alinea para que algo importante suceda.
                  Ese es el territorio en el que operamos.
                </p>
                <p>
                  Kairós Learning es la entidad franquiciadora de un sistema educativo estructurado, diseñado para que
                  inversionistas puedan operarlo de forma autónoma y rentable, sin necesidad de crear una institución
                  educativa desde cero. Tomamos veinte años de arquitectura académica, alianzas universitarias y flujos
                  de generación de demanda, y los convertimos en un negocio 100% digital, listo para escalar en cualquier
                  territorio de Latinoamérica.
                </p>
                <p>
                  Construimos el momento preciso para que un franquiciatario entre a la industria educativa con toda la
                  infraestructura ya resuelta: catálogo, marca, demanda y respaldo institucional, operando desde el día uno.
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-4 bg-crimson/5 blur-2xl rounded-full" />
              <img src={BRAND_GRAPHIC} alt="Kairós — el instante preciso" className="relative w-full h-auto object-contain rounded-sm" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
